import { TInputParams } from 'entries/common/widgets/context';
import { ParametersEnum } from '../types';

export const getAreaState = ({
  inputParams,
  isEnabled,
}: {
  inputParams: TInputParams;
  isEnabled: boolean;
}) => {
  const withArea = inputParams.filter(
    param => ![ParametersEnum.length, ParametersEnum.width].includes(param)
  );
  return isEnabled ? [ParametersEnum.area, ...withArea] : inputParams;
};
